import React from 'react';
import './Products.css'
import Card from '../../shared/components/UIElements/Card';

function CustomSliders() {
  return (
    <Card className='zipper-container'>
      <div className='zipper-element'>
        <img src="/custom-sliders.jpg" alt="st sign"/>
      </div>
      <div className='zipper-text'>
        <h2>Custom Sliders</h2>
        <p>A zipper is a little machine.  
          It is usually the only part of a garment that has moving parts. 
           The slider assembly is the “train” that runs on the tracks, in some instances, many times a day.  
           Some sliders may have more than seven separate parts. 
            Quality tooling and engineered compatibility are essential to proper functioning and durability. 
             We offer customization services that enable you to utilize the zipper pull as a sales tool – communicating your company’s name or logo - as well as promoting your fashion sense.
              We keep an extensive collection of decorative zipper pulls geared for all fashion markets.  
              AGH is one of the few companies to offer over 50 different metallic finishes that will give your zipper pull and slider bodies a distinctive coordinated appearance. Our AGH Design Services will transform your concept into reality within a matter of weeks.	 </p>
      </div>
    </Card>
  )
}



export default CustomSliders;